/** Chiavi persistenti per card/promo Home (sopravvivono al logout). */
export const HOME_PRIVATE_APP_PROMO_DISMISSED_KEY = 'home_private_app_promo_dismissed';

/**
 * Novità gestionale. Bump a v2 quando pubblichi un nuovo set di novità:
 * banner e modal torneranno a mostrarsi a tutti.
 */
export const HOME_WHATS_NEW_VERSION = 'v1';
/** "Non mostrare più" sul BANNER: nasconde banner (e quindi anche l'auto-open del modal). */
export const HOME_WHATS_NEW_BANNER_DISMISSED_KEY = `home_whats_new_${HOME_WHATS_NEW_VERSION}_banner_dismissed`;
/** Modal chiuso una volta (X, overlay, "Ho capito"): non si apre più da solo, il banner resta. */
export const HOME_WHATS_NEW_MODAL_DISMISSED_KEY = `home_whats_new_${HOME_WHATS_NEW_VERSION}_modal_dismissed`;

/** "Non mostrare più" sulla card Ambassador in Home. */
export const HOME_AMBASSADOR_CARD_DISMISSED_KEY = 'home_ambassador_card_dismissed';
/**
 * Chiusura della notifica Ambassador in calendario.
 * v2 ignora chi l'aveva già chiusa con la chiave precedente: torna visibile a tutti.
 */
export const SCHEDULER_AMBASSADOR_BANNER_DISMISSED_KEY = 'scheduler_ambassador_banner_v2_dismissed';

/** Icona "Novità" sulla voce Home: sparisce dopo la prima visita alla Home. */
export const HOME_NAV_NEW_SEEN_KEY = 'home_nav_new_seen_v2';

export const HOME_PERSISTED_PROMO_KEYS = [
  HOME_PRIVATE_APP_PROMO_DISMISSED_KEY,
  HOME_WHATS_NEW_BANNER_DISMISSED_KEY,
  HOME_WHATS_NEW_MODAL_DISMISSED_KEY,
  HOME_AMBASSADOR_CARD_DISMISSED_KEY,
  SCHEDULER_AMBASSADOR_BANNER_DISMISSED_KEY,
  HOME_NAV_NEW_SEEN_KEY,
];

export const readLocalFlag = (key) => {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
};

export const writeLocalFlag = (key) => {
  try {
    localStorage.setItem(key, '1');
  } catch {
    // private mode / quota
  }
};
